/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationDocumentApprovalCourseregistrationidDocumentEnrollmentdocumentidStatus200,
  GetApiV1CourseregistrationDocumentApprovalCourseregistrationidDocumentEnrollmentdocumentidStatus401,
  GetApiV1CourseregistrationDocumentApprovalCourseregistrationidDocumentEnrollmentdocumentidStatus404,
  GetApiV1CourseregistrationDocumentApprovalCourseregistrationidDocumentEnrollmentdocumentidStatus500,
  GetApiV1CourseregistrationDocumentApprovalCourseregistrationidDocumentEnrollmentdocumentidStatusPathParams,
  GetApiV1CourseregistrationDocumentApprovalCourseregistrationidDocumentEnrollmentdocumentidStatusQueryParams,
  GetApiV1CourseregistrationDocumentApprovalCourseregistrationidDocumentEnrollmentdocumentidStatusQueryResponse,
} from "../../types/courseRegistrationDocumentApprovalController/GetApiV1CourseregistrationDocumentApprovalCourseregistrationidDocumentEnrollmentdocumentidStatus.ts";
import { personDocumentApprovalStatusViewModelSchema } from "../personDocumentApprovalStatusViewModelSchema.ts";

export const getApiV1CourseregistrationDocumentApprovalCourseregistrationidDocumentEnrollmentdocumentidStatusPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
    enrollmentDocumentId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1CourseregistrationDocumentApprovalCourseregistrationidDocumentEnrollmentdocumentidStatusPathParams>;

export const getApiV1CourseregistrationDocumentApprovalCourseregistrationidDocumentEnrollmentdocumentidStatusQueryParamsSchema =
  z
    .object({
      attachmentId: z.optional(z.coerce.number().int()),
    })
    .optional() as unknown as ToZod<GetApiV1CourseregistrationDocumentApprovalCourseregistrationidDocumentEnrollmentdocumentidStatusQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationDocumentApprovalCourseregistrationidDocumentEnrollmentdocumentidStatus200Schema =
  z.lazy(
    () => personDocumentApprovalStatusViewModelSchema,
  ) as unknown as ToZod<GetApiV1CourseregistrationDocumentApprovalCourseregistrationidDocumentEnrollmentdocumentidStatus200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationDocumentApprovalCourseregistrationidDocumentEnrollmentdocumentidStatus401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationDocumentApprovalCourseregistrationidDocumentEnrollmentdocumentidStatus401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1CourseregistrationDocumentApprovalCourseregistrationidDocumentEnrollmentdocumentidStatus404Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationDocumentApprovalCourseregistrationidDocumentEnrollmentdocumentidStatus404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationDocumentApprovalCourseregistrationidDocumentEnrollmentdocumentidStatus500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationDocumentApprovalCourseregistrationidDocumentEnrollmentdocumentidStatus500>;

export const getApiV1CourseregistrationDocumentApprovalCourseregistrationidDocumentEnrollmentdocumentidStatusQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1CourseregistrationDocumentApprovalCourseregistrationidDocumentEnrollmentdocumentidStatus200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationDocumentApprovalCourseregistrationidDocumentEnrollmentdocumentidStatusQueryResponse>;
